import script from "./PermanentDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./PermanentDelete.vue?vue&type=script&setup=true&lang=js"

import "./PermanentDelete.vue?vue&type=style&index=0&id=0e51ebca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e51ebca"]])

export default __exports__